import { useSelector } from 'react-redux';

/**
 * Gate de permissão de fase compartilhado — extraído na 4ª ocorrência do
 * mesmo padrão no módulo (`AcoesEmMassaMenu.jsx`, `AbaAcompanhamento.jsx`,
 * `BlocoAnotacao.jsx`/AW2-1055 Etapa 1, e agora `MudancaFaseEnvio.jsx`/
 * AW2-1056), já registrada como débito em `src/prototipo/CLAUDE.md`.
 *
 * Fail-closed: `idFaseAtual` ausente (dado do processo ainda não carregado)
 * ou `fasesPermitidasUsuario` ausente/vazio/não-array nunca habilita a ação
 * por omissão — a autorização real permanece 100% no backend do service
 * chamado por quem usa este hook; ele é só UX (AC: "desabilitado, não
 * oculto, sem mensagem de bloqueio").
 */
export default function usePodeAtuarNaFase(idFaseAtual) {
  const fasesPermitidasUsuario = useSelector(state => state.authentication.userInformation.fases);

  return idFaseAtual != null
    && Array.isArray(fasesPermitidasUsuario)
    && fasesPermitidasUsuario.some(faseUsuario => Number(faseUsuario) === Number(idFaseAtual));
}
